(() => {
  const root = document.querySelector('[data-selene-popup]');
  if (!root) return;
  const dialog = root.querySelector('.snp-dialog');
  const close = root.querySelector('[data-selene-popup-close]');
  const storageKey = 'selene-free-reading-popup-session-v2';
  try {
    if (sessionStorage.getItem(storageKey)) return;
    sessionStorage.setItem(storageKey, 'scheduled');
  } catch (_) {}
  const dismiss = () => {
    root.classList.remove('is-visible');
    document.documentElement.classList.remove('snp-locked');
    setTimeout(() => { root.hidden = true; }, 260);
  };
  const show = () => {
    root.hidden = false;
    requestAnimationFrame(() => {
      root.classList.add('is-visible');
      document.documentElement.classList.add('snp-locked');
      dialog?.focus();
    });
  };
  close?.addEventListener('click', dismiss);
  root.addEventListener('click', (event) => { if (event.target === root) dismiss(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !root.hidden) dismiss(); });
  window.setTimeout(show, 5000);
})();
